import React from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,

  FacebookIcon,
  LinkedinIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";
import reffer from '../assets/reffer.svg'

export default function SocialMediaButtons(props) {

  const {recieverMessage,refLink,refCode,senderMessage,senderMessage1,title} = props.refData?props.refData:""
  const isSubscribed = props.Disabled

  console.log(isSubscribed)
  return (
      <div className="d-flex justify-content-center">
    <FacebookShareButton
      url={refLink}
      quote={senderMessage}
      hashtag="#DownloadClapingoApp"
      disabled={isSubscribed}
    >
      <FacebookIcon size={42} />
    </FacebookShareButton>
    <LinkedinShareButton
     url={refLink}
     title={senderMessage}
     summary={recieverMessage}
     disabled={isSubscribed}
    >
      <LinkedinIcon size={42} />
    </LinkedinShareButton>
    <TelegramShareButton
      url={refLink}
      quote={senderMessage}
      disabled={isSubscribed}
    >
      <TelegramIcon size={42} />
    </TelegramShareButton>
    
    <WhatsappShareButton
     url={refLink}
     title={`*${senderMessage}* ${"  "} ${recieverMessage}`}
     media={"https://learn.g2.com/hubfs/create-referral-program.jpg"}
     separator=":: "
     disabled={isSubscribed}
    >
      <WhatsappIcon size={42} />
    </WhatsappShareButton>
    
    <TwitterShareButton
      url={refLink}
      title={senderMessage}
      hashtag="#DownloadClapingoApp"
      disabled={isSubscribed}
    >
      <TwitterIcon size={42} />
    </TwitterShareButton>
    
    </div>
  );
}
